import { render } from "./index.vue?vue&type=template&id=a36c3d26&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=a36c3d26&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a36c3d26"

export default script